import { z } from "zod";
import toFirestoreSchema from "../utils/toFirestoreSchema";

/**
 * SESSION SCHEMA
 * Represents a single meeting session (top-level collection)
 */
export const SessionSchema = z.object({
    /** Reference to the book */
    bookId: z.string().describe("Reference to book document"),

    /** Maximum capacity for this session */
    capacity: z.number().int().positive().describe("Maximum attendees per session"),

    /** When the session was created */
    createdAt: z.date().describe("When the session was created"),

    // day: z
    //     .enum(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"])
    //     .describe("Day of the week"),

    /** Unique session identifier */
    id: z.string().describe("Unique session identifier"),

    /** Maximum number of tables for this session */
    maxTableCount: z.number().int().positive().describe("Maximum number of tables for this session"),

    /** Session date and time in UTC (ISO datetime string) */
    scheduledAt: z.string().datetime().describe("Session date and time in UTC (ISO datetime)"),

    /** Number of attendees who actually attended */
    totalAttendees: z.number().int().min(0).default(0).describe("Number of attendees"),

    /** Number of bookings for this session */
    totalBookings: z.number().int().min(0).default(0).describe("Number of bookings"),

    /** Reference to the venue */
    venueId: z.string().describe("Reference to venue document"),
});

export const SessionRecordSchema = toFirestoreSchema(SessionSchema);

// Type export
export type Session = z.infer<typeof SessionSchema>;
export type SessionRecord = z.infer<typeof SessionRecordSchema>;
